/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourShotsGridGenerateMutationVariables = {
    tourId: string;
};
export type TourShotsGridGenerateMutationResponse = {
    readonly generateTourShots: {
        readonly tour: {
            readonly id: string;
            readonly shots: ReadonlyArray<{
                readonly id: string;
            }>;
        };
    };
};
export type TourShotsGridGenerateMutation = {
    readonly response: TourShotsGridGenerateMutationResponse;
    readonly variables: TourShotsGridGenerateMutationVariables;
};



/*
mutation TourShotsGridGenerateMutation(
  $tourId: ID!
) {
  generateTourShots(input: {tourId: $tourId}) {
    tour {
      id
      shots {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tourId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "tourId",
            "variableName": "tourId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "GenerateTourShotsPayload",
    "kind": "LinkedField",
    "name": "generateTourShots",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tour",
        "kind": "LinkedField",
        "name": "tour",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Shot",
            "kind": "LinkedField",
            "name": "shots",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourShotsGridGenerateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourShotsGridGenerateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "30b739413fee746e92dfb4c22d959061",
    "id": null,
    "metadata": {},
    "name": "TourShotsGridGenerateMutation",
    "operationKind": "mutation",
    "text": "mutation TourShotsGridGenerateMutation(\n  $tourId: ID!\n) {\n  generateTourShots(input: {tourId: $tourId}) {\n    tour {\n      id\n      shots {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '8707699568bf1b3817915c12fb8c70cd';
export default node;
